import * as React from "react";

function SvgExtend(props) {
  return (
    <span className={"iiht-svg"}>
      <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" {...props}>
        <g id="Group_12207" data-name="Group 12207" transform="translate(-2859.239 -1697.239)">
          <rect
            id="Rectangle_4113"
            data-name="Rectangle 4113"
            width="31"
            height="31"
            transform="translate(2859.239 1697.239)"
            fill="none"
          />
          <g id="noun-extend-3858690" transform="translate(2864.294 1702.294)">
            <path
              id="Path_43843"
              data-name="Path 43843"
              d="M70.346,5.46a.342.342,0,0,0,.342-.342V1.161a.342.342,0,0,0,.483-.483h3.958a.342.342,0,1,0,0-.683h-4.1A1.026,1.026,0,0,0,70,1.02v4.1a.342.342,0,0,0,.342.342Z"
              transform="translate(-70.004 0.005)"
              fill="#424242"
            />
            <path
              id="Path_43843_-_Outline"
              data-name="Path 43843 - Outline"
              d="M70.346,5.835h-.977L69.74,5.5a.712.712,0,0,1-.111-.382V1.02a1.4,1.4,0,0,1,1.4-1.4h4.1a.717.717,0,1,1,0,1.433h-3.5a.716.716,0,0,1-.57.571V5.085h.261l-.3.271A.718.718,0,0,1,70.346,5.835Z"
              transform="translate(-70.004 0.005)"
              fill="#424242"
            />
            <path
              id="Path_43844"
              data-name="Path 43844"
              d="M495.123,420a.342.342,0,0,0-.342.342V424.3a.341.341,0,0,0-.483.483h-3.958a.342.342,0,0,0,0,.683h4.1a1.026,1.026,0,0,0,1.025-1.025v-4.1a.342.342,0,0,0-.342-.342Z"
              transform="translate(-473.604 -403.604)"
              fill="#424242"
            />
            <path
              id="Path_43844_-_Outline"
              data-name="Path 43844 - Outline"
              d="M495.123,419.625h0a.717.717,0,0,1,.717.717v4.1a1.4,1.4,0,0,1-1.4,1.4h-4.1a.717.717,0,0,1,0-1.433h3.5a.716.716,0,0,1,.569-.57v-3.5A.717.717,0,0,1,495.123,419.625Z"
              transform="translate(-473.604 -403.604)"
              fill="#424242"
            />
            <path
              id="Path_43845"
              data-name="Path 43845"
              d="M494.44,0h-4.1a.342.342,0,0,0,0,.683H494.3a.342.342,0,0,0,.483.483V5.124a.342.342,0,1,0,.683,0v-4.1A1.026,1.026,0,0,0,494.44,0Z"
              transform="translate(-473.604 0)"
              fill="#424242"
            />
            <path
              id="Path_43845_-_Outline"
              data-name="Path 43845 - Outline"
              d="M490.342-.375h4.474v.051a1.4,1.4,0,0,1,1.025,1.349v4.1a.717.717,0,1,1-1.433,0v-3.5a.717.717,0,0,1-.57-.57h-3.5a.717.717,0,0,1,0-1.433Z"
              transform="translate(-473.604 0)"
              fill="#424242"
            />
            <path
              id="Path_43846"
              data-name="Path 43846"
              d="M71.02,425.464h4.1a.342.342,0,1,0,0-.683H71.162a.342.342,0,0,0-.483-.483v-3.958a.342.342,0,1,0-.683,0v4.1a1.026,1.026,0,0,0,1.025,1.025Z"
              transform="translate(-69.995 -403.603)"
              fill="#424242"
            />
            <path
              id="Path_43846_-_Outline"
              data-name="Path 43846 - Outline"
              d="M75.119,425.839h-4.1a1.4,1.4,0,0,1-1.4-1.4v-4.1a.717.717,0,1,1,1.433,0v3.5a.717.717,0,0,1,.57.57h3.5a.717.717,0,1,1,0,1.433Z"
              transform="translate(-69.995 -403.603)"
              fill="#424242"
            />
            <path
              id="Path_43847"
              data-name="Path 43847"
              d="M493.943,423.465a.34.34,0,0,0-.167-.091,1.722,1.722,0,0,1-.407.407.341.341,0,0,0,.091.167l.453.453a.352.352,0,0,0,.483,0,.341.341,0,0,0,0-.483Z"
              transform="translate(-476.842 -406.847)"
              fill="#424242"
            />
            <path
              id="Path_43847_-_Outline"
              data-name="Path 43847 - Outline"
              d="M493.613,422.955l.242.053a.714.714,0,0,1,.352.192l.453.454a.716.716,0,0,1,0,1.013l-.008.008a.727.727,0,0,1-1,0l-.008-.007-.453-.453a.715.715,0,0,1-.192-.352l-.053-.242.2-.144a1.343,1.343,0,0,0,.318-.318Z"
              transform="translate(-476.842 -406.847)"
              fill="#424242"
            />
            <path
              id="Path_43848"
              data-name="Path 43848"
              d="M562.859,493.349l.453.453h0a.346.346,0,0,0,.483,0,.342.342,0,0,0,0-.483l-.453-.453a.342.342,0,0,0-.483.483Z"
              transform="translate(-543.523 -473.53)"
              fill="#424242"
            />
            <path
              id="Path_43848_-_Outline"
              data-name="Path 43848 - Outline"
              d="M563.554,494.275a.717.717,0,0,1-.5-.2l-.66-.644h.069a.717.717,0,0,1,1.148-.827l.453.453a.717.717,0,0,1,.023.989l.134.134h-.3A.718.718,0,0,1,563.554,494.275Z"
              transform="translate(-543.523 -473.53)"
              fill="#424242"
            />
            <path
              id="Path_43849"
              data-name="Path 43849"
              d="M528.058,458.54l.453.453a.345.345,0,0,0,.483,0,.341.341,0,0,0,0-.483l-.453-.453a.342.342,0,0,0-.483.483Z"
              transform="translate(-510.081 -440.08)"
              fill="#424242"
            />
            <path
              id="Path_43849_-_Outline"
              data-name="Path 43849 - Outline"
              d="M528.753,459.466a.716.716,0,0,1-.5-.206l-.456-.456a.717.717,0,0,1,1.013-1.014l.453.454a.712.712,0,0,1,.21.507.714.714,0,0,1-.717.715Z"
              transform="translate(-510.081 -440.08)"
              fill="#424242"
            />
            <path
              id="Path_43850"
              data-name="Path 43850"
              d="M108.7,492.865l-.453.453a.342.342,0,0,0,0,.483.347.347,0,0,0,.483,0l.453-.453h0a.342.342,0,0,0-.483-.483Z"
              transform="translate(-106.653 -473.529)"
              fill="#424242"
            />
            <path
              id="Path_43850_-_Outline"
              data-name="Path 43850 - Outline"
              d="M108.937,492.39a.716.716,0,0,1,.7.583h.443l-1.1,1.1a.722.722,0,0,1-1.005,0l0,0a.717.717,0,0,1,0-1.013l.453-.453A.712.712,0,0,1,108.937,492.39Z"
              transform="translate(-106.653 -473.529)"
              fill="#424242"
            />
            <path
              id="Path_43851"
              data-name="Path 43851"
              d="M143.506,458.063l-.453.453a.341.341,0,0,0,0,.483.351.351,0,0,0,.483,0l.453-.453a.341.341,0,0,0-.483-.483Z"
              transform="translate(-140.104 -440.086)"
              fill="#424242"
            />
            <path
              id="Path_43851_-_Outline"
              data-name="Path 43851 - Outline"
              d="M143.746,457.589a.717.717,0,0,1,.508,1.222l-.461.461a.726.726,0,0,1-1,0l-.007-.007a.716.716,0,0,1,0-1.013l.453-.453A.712.712,0,0,1,143.746,457.589Z"
              transform="translate(-140.104 -440.086)"
              fill="#424242"
            />
            <path
              id="Path_43852"
              data-name="Path 43852"
              d="M177.854,424.394a.352.352,0,0,0,.483,0l.453-.453a.34.34,0,0,0,.091-.167,1.722,1.722,0,0,1-.407-.407.339.339,0,0,0-.167.091l-.453.453h0a.341.341,0,0,0,0,.483Z"
              transform="translate(-173.547 -406.84)"
              fill="#424242"
            />
            <path
              id="Path_43852_-_Outline"
              data-name="Path 43852 - Outline"
              d="M178.095,424.865a.725.725,0,0,1-.5-.2l-.008-.008a.722.722,0,0,1-.2-.373h-.443l1.093-1.093a.713.713,0,0,1,.353-.193l.242-.052.143.2a1.344,1.344,0,0,0,.318.318l.2.144-.053.242a.714.714,0,0,1-.192.352l-.461.461A.724.724,0,0,1,178.095,424.865Z"
              transform="translate(-173.547 -406.84)"
              fill="#424242"
            />
            <path
              id="Path_43853"
              data-name="Path 43853"
              d="M109.176,38.694l-.453-.453a.342.342,0,0,0-.483.483l.453.453a.351.351,0,0,0,.483,0,.341.341,0,0,0,0-.483Z"
              transform="translate(-106.65 -36.652)"
              fill="#424242"
            />
            <path
              id="Path_43853_-_Outline"
              data-name="Path 43853 - Outline"
              d="M108.481,37.766a.712.712,0,0,1,.507.21l.453.453a.716.716,0,0,1,0,1.013l-.007.007a.726.726,0,0,1-1,0l-.007-.007-.453-.453a.717.717,0,0,1,.507-1.223Z"
              transform="translate(-106.65 -36.652)"
              fill="#424242"
            />
            <path
              id="Path_43854"
              data-name="Path 43854"
              d="M144,73.513l-.453-.453a.341.341,0,0,0-.483.483l.453.453A.346.346,0,0,0,144,74a.342.342,0,0,0,0-.483Z"
              transform="translate(-140.114 -70.112)"
              fill="#424242"
            />
            <path
              id="Path_43854_-_Outline"
              data-name="Path 43854 - Outline"
              d="M143.3,72.585a.712.712,0,0,1,.506.209l.454.454a.716.716,0,0,1,0,1.013.721.721,0,0,1-1.01,0l-.456-.456a.717.717,0,0,1,.507-1.223Z"
              transform="translate(-140.114 -70.112)"
              fill="#424242"
            />
            <path
              id="Path_43855"
              data-name="Path 43855"
              d="M178.3,108.779a.339.339,0,0,0,.167.091,1.724,1.724,0,0,1,.407-.407.34.34,0,0,0-.091-.167l-.453-.453a.341.341,0,1,0-.483.483Z"
              transform="translate(-173.541 -103.536)"
              fill="#424242"
            />
            <path
              id="Path_43855_-_Outline"
              data-name="Path 43855 - Outline"
              d="M178.631,109.289l-.242-.052a.712.712,0,0,1-.353-.192l-.453-.453a.716.716,0,1,1,1.014-1.013l.452.452a.714.714,0,0,1,.192.352l.053.242-.2.144a1.345,1.345,0,0,0-.318.318Z"
              transform="translate(-173.541 -103.536)"
              fill="#424242"
            />
            <path
              id="Path_43856"
              data-name="Path 43856"
              d="M494.4,107.86a.341.341,0,0,0-.483,0l-.453.453a.341.341,0,0,0-.091.167,1.722,1.722,0,0,1,.407.407.338.338,0,0,0,.167-.091l.453-.453h0a.341.341,0,0,0,0-.483Z"
              transform="translate(-476.844 -103.553)"
              fill="#424242"
            />
            <path
              id="Path_43856_-_Outline"
              data-name="Path 43856 - Outline"
              d="M494.157,107.385a.717.717,0,0,1,.7.583h.443l-1.093,1.093a.712.712,0,0,1-.353.193l-.242.052-.143-.2a1.343,1.343,0,0,0-.318-.318l-.2-.144L493,108.4a.715.715,0,0,1,.192-.351l.454-.454A.711.711,0,0,1,494.157,107.385Z"
              transform="translate(-476.844 -103.553)"
              fill="#424242"
            />
            <path
              id="Path_43857"
              data-name="Path 43857"
              d="M563.087,39.281a.341.341,0,0,0,.241-.1l.453-.453a.342.342,0,0,0-.483-.483l-.453.453h0a.34.34,0,0,0,.242.582Z"
              transform="translate(-543.509 -36.657)"
              fill="#424242"
            />
            <path
              id="Path_43857_-_Outline"
              data-name="Path 43857 - Outline"
              d="M563.085,39.656a.717.717,0,0,1-.7-.582h-.442l1.093-1.093a.717.717,0,0,1,1.014,1.013l-.453.453a.712.712,0,0,1-.5.208Z"
              transform="translate(-543.509 -36.657)"
              fill="#424242"
            />
            <path
              id="Path_43858"
              data-name="Path 43858"
              d="M528.251,74.1a.341.341,0,0,0,.242-.1l.453-.453a.341.341,0,0,0-.483-.483l-.453.453a.337.337,0,0,0,.241.579Z"
              transform="translate(-510.032 -70.116)"
              fill="#424242"
            />
            <path
              id="Path_43858_-_Outline"
              data-name="Path 43858 - Outline"
              d="M528.245,74.471a.712.712,0,0,1-.5-1.222l.45-.45a.716.716,0,0,1,1.014,1.013l-.458.458a.713.713,0,0,1-.5.2h-.011Z"
              transform="translate(-510.032 -70.116)"
              fill="#424242"
            />
            <path
              id="Path_43859"
              data-name="Path 43859"
              d="M215.867,135.62h-9.223a1.026,1.026,0,0,0-1.025,1.025v9.223a1.026,1.026,0,0,0,1.025,1.025h9.223a1.026,1.026,0,0,0,1.025-1.025v-9.223a1.026,1.026,0,0,0-1.025-1.025Zm.342,10.247a.342.342,0,0,1-.342.342h-9.223a.342.342,0,0,1-.342-.342v-9.223a.342.342,0,0,1,.342-.342h9.223a.342.342,0,0,1,.342.342Z"
              transform="translate(-200.325 -130.326)"
              fill="#424242"
            />
            <path
              id="Path_43859_-_Outline"
              data-name="Path 43859 - Outline"
              d="M206.644,135.245h9.223a1.4,1.4,0,0,1,1.4,1.4v9.223a1.4,1.4,0,0,1-1.4,1.4h-9.223a1.4,1.4,0,0,1-1.4-1.4v-9.223a1.4,1.4,0,0,1,1.4-1.4Zm9.19,1.433h-9.156v9.156h9.156Z"
              transform="translate(-200.325 -130.326)"
              fill="#424242"
            />
          </g>
        </g>
      </svg>
    </span>
  );
}

export default SvgExtend;
